import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneNews from "./OneNews";

export default function NewsBanner(props) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllNews()]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  const newsToDisplay =
    ready && appContext.allNews
      ? props.limit
        ? appContext.allNews.slice(0, props.limit)
        : appContext.allNews
      : [];

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section className="MainBodySection bg-background" style={{ padding: "40px 0" }}>
      <div className="container">
        {props.showHeader !== false && (
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-4">
            <div>
              <h4 className="main-section-title mb-1">Latest News</h4>
              <small className="text-muted">
                Updates and stories from Tanzania Editors’ Forum
              </small>
            </div>
            {props.limit && (
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => appContext.navTo({ item: "news" })}
              >
                View all
              </button>
            )}
          </div>
        )}

        <div className="row g-4">
          {newsToDisplay && newsToDisplay.length > 0 ? (
            newsToDisplay.map((item, i) => (
              <div key={i} className="col-lg-4 col-md-6">
                <OneNews data={item} />
              </div>
            ))
          ) : (
            <div className="col-12 text-center text-muted py-4">
              No news found.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
